import React from 'react';
import { MenuItem, Typography, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';

const SectionBox = styled('div')({
  marginBottom: '16px',
});

const PeriodScrollablePaper = styled(Paper)({
  maxHeight: '300px',
  overflow: 'auto',
});

const periodMenuItemStyles = {
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  paddingTop: '12px',
  paddingBottom: '12px',
};

const PeriodText = styled(Typography)(({ theme, isSelected }) => ({
  fontSize: {
    xs: '0.75rem',
    sm: '0.875rem',
    md: '1rem',
  },
  fontWeight: isSelected ? 'bold' : 'normal',
  width: '100%',
}));

const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString(undefined, { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });
};

const PeriodSelector = ({ 
  validPeriods, 
  selectedPeriod, 
  onPeriodChange 
}) => {
  // Separate active and past periods
  const activePeriod = validPeriods.find(period => period.isCurrentPeriod);
  const pastPeriods = validPeriods
    .filter(period => !period.isCurrentPeriod)
    .sort((a, b) => new Date(b.weekStart) - new Date(a.weekStart));

  return (
    <SectionBox>
      {/* Active Period Section */}
      {activePeriod && (
        <>
          <Typography variant="subtitle1" color="text.primary" sx={{ mb: 1 }}>
            Active Period
          </Typography>
          <PeriodScrollablePaper variant="outlined">
            <MenuItem 
              key={activePeriod.weekStart} 
              onClick={() => onPeriodChange(activePeriod.weekStart)}
              selected={selectedPeriod === activePeriod.weekStart}
              sx={periodMenuItemStyles}
            >
              <PeriodText isSelected={selectedPeriod === activePeriod.weekStart}>
                {formatDate(activePeriod.weekStart)} - {formatDate(activePeriod.weekEnd)} (Active)
              </PeriodText>
            </MenuItem>
          </PeriodScrollablePaper>
        </>
      )}

      {/* Past Periods Section */}
      {pastPeriods.length > 0 && (
        <>
          <Typography variant="subtitle1" color="text.primary" sx={{ mb: 1, mt: 1 }}>
            Past Periods
          </Typography>
          <PeriodScrollablePaper variant="outlined">
            {pastPeriods.map(({ weekStart, weekEnd }, index) => {
              return (
                <MenuItem 
                  key={index} 
                  onClick={() => onPeriodChange(weekStart)}
                  selected={selectedPeriod === weekStart}
                  sx={periodMenuItemStyles}
                >
                  <PeriodText isSelected={selectedPeriod === weekStart}>
                    {formatDate(weekStart)} - {formatDate(weekEnd)}
                  </PeriodText>
                </MenuItem>
              );
            })}
          </PeriodScrollablePaper>
        </>
      )}
    </SectionBox>
  );
};

export default PeriodSelector; 